import {
  GET_ASSET_WORKSPACE,
  CREATE_ASSET_IMPORT_SOURCE,
  CREATE_ASSET_IMPORT_TOKEN,
  GET_ASSET_SCHEMAS,
  SET_SELECTED_ASSET_SCHEMA,
  SET_IMPORT_SOURCE_NAME,
  SET_OBJECT_TYPE_NAME,
  CLEAR_ASSET,
} from "../actions/types";
const initialState = {
  workspace: "",
  token: "",
  importSource: {},
  assetSchemas: null,
  selectedAssetSchema: null,
  importSourceName: "",
  objectTypeName: "",
};
const getSchemasIfExists = (payload) => {
  if (!payload) {
    return null;
  }
  return payload.values ? payload.values : null;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_WORKSPACE:
      return {
        ...state,
        workspace: action.payload,
      };
    case CREATE_ASSET_IMPORT_SOURCE:
      return {
        ...state,
        importSource: action.payload,
      };
    case CREATE_ASSET_IMPORT_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case SET_SELECTED_ASSET_SCHEMA:
      return {
        ...state,
        selectedAssetSchema: action.payload,
      };
    case GET_ASSET_SCHEMAS:
      return {
        ...state,
        assetSchemas: getSchemasIfExists(action.payload),
      };
    case SET_IMPORT_SOURCE_NAME:
      return {
        ...state,
        importSourceName: action.payload,
      };
    case SET_OBJECT_TYPE_NAME:
      return {
        ...state,
        objectTypeName: action.payload,
      };
    case CLEAR_ASSET:
      return {
        ...state,
        workspace: "",
        token: "",
        importSource: {},
        assetSchemas: null,
        selectedAssetSchema: null,
        importSourceName: "",
        objectTypeName: "",
      };
    default:
      return state;
  }
}
